import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { patchApexCharts } from 'app/core/error-handler/apex-charts-patch';

// Patch ng-apexcharts to prevent "Element not found" / "node" errors
// from poisoning Zone.js during route transitions.
patchApexCharts();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
